export default __webpack_public_path__ + "static/media/DropdownIcon.3369b945.svg";